// eslint-disable-next-line no-magic-numbers
export default 40;
